<template>
	<div class="sequence" :class="{'to': !this.from,'from':this.from}">
		<div v-for="(message,index) in messages" :key="index" class="item" >
			<span v-if="typeof user.fbId !== 'undefined' && user.fbId !== ''" class="icon">
				<img width="38" height="38" :src="'https://graph.facebook.com/'+user.fbId+'/picture?width=76&height=76&type=normal'" alt="">
			</span>
			<span v-else class="icon text">{{initials}}</span>
            <span class="text">
                <div class="username">{{username}}</div>
                <span v-html="nl2br(message)"></span>
            </span>
		</div>
	</div>
</template>

<script>
	export default {
		computed:{
			username(){
				const fullname = this.user.displayName.split(' ');
				let name = fullname[0]
                return name
            },
			initials(){
				const parts = this.user.displayName.split(' ');
				let initials = '';
				parts.forEach(part => {
					initials += part[0];
				})
				return initials;
			}
		},
		methods: {
			nl2br(message){
				return message.replace(/\n/g,"<br />")
			}
		},
		props:{
			messages: {
				type: Array,
				required: true
			},
			user: {
				type: Object,
				required: true
			},
			from:{
				type: Boolean,
				default: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sequence{
        margin-top: 12px;
		&.to .item{
			margin-left: 0;
			margin-right: 55px;
		}
		.item{
			display: block;
			margin-top: 5px;
			border-radius: 8px;
			padding: 15px 25px 15px 65px;
			position: relative;
			background: $white;
			color: $dark;
			font-size: 14px;
			line-height: 1.35em;
			margin-left: 55px;
			.icon{
				display: block;
				width: 38px;
				height: 38px;
				border-radius: 50%;
				position: absolute;
				top: 15px;
				left: 15px;
				background: #EEE;
				overflow: hidden;
				&.text{
					text-align: center;
					line-height: 38px;
					text-transform: uppercase;
					font-size: 14px;
				}
			}
            .username{
                font-size: 12px;
                font-weight: bold;
            }
            &:first-of-type{
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }
            &:last-of-type{
                border-bottom-left-radius: 20px;
                border-bottom-right-radius: 20px;
                .icon{
                    display: block;
                }
            }
		}
	}
</style>
